import Commons from '../Services/Common/Common';
import Global from '../Services/Common/Global';
import { apiRequest } from '../Services/Common/ApiRequest';
import useSearchMutation from './apis/useSearchMutaion';

export default function useSearchUser() {
  const mutation = useSearchMutation(async (context) => {
    const params = {
      Userid: Commons.EncryptAES(context.userId),
    };

    const result = await apiRequest(
      'post',
      Global.urls.Utility.getMember,
      params
    );

    return result.data;
  });

  const searchUser = async (userId) => {
    try {
      const response = await mutation.mutateAsync({ userId });

      return response?.data || response;
    } catch (error) {
      console.error('❌ 사용자 조회 실패:', error);
      return null;
    }
  };

  return { searchUser };
}
